import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';
import { Router } from '@angular/router';
import { Occurence } from 'src/app/model/breakdowns/breakdown';
import { CallStat, CodePanne } from 'src/app/model/call/call.model';

@Component({
  selector: 'app-intervention-analysis',
  templateUrl: './intervention-analysis.component.html',
  styleUrls: ['./intervention-analysis.component.scss']
})
export class InterventionAnalysisComponent implements OnInit {

  selectedPannes!: CodePanne[];
  public startCP: any;
  public endCP: any;


  get displayedColumnNbCodePanne(): string[] {
    const result: string[] = ['code', 'dap', 'nb'];
    return result;
  }

  constructor(private service: CallService,
    private builder: FormBuilder,
    private utils: UtilsService,
    private router: Router) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;


  /**
   * Existing breakdown codes
   */
  codesPannes!: CodePanne[];


  /**
   * Date Pickers Form for Code Panne
   */
  rapportInterventionsForm!: FormGroup;



  /**
   * List of nb of code panne
   */
  nbCodePanne !: Occurence[];

  ngOnInit(): void {

    /** Load the breakdowns codes available */
    this.service.getCodesPannes().subscribe((codesPannes) => {
      this.codesPannes = codesPannes;
      this.selectedPannes = this.codesPannes;
    });


    this.rapportInterventionsForm = this.builder.group({
      startDateCodePanne: ['', Validators.required],
      endDateCodePanne: ['', Validators.required]
    }
    );
  }




  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }


  onKey(event: any) {

    this.selectedPannes = this.searchPannes(event.target.value);
  }

  searchPannes(value: string) {
    let filter = value.toLowerCase();
    return this.codesPannes.filter(option => option.nom.toLowerCase().includes(filter) || option.code.toLowerCase().includes(filter));
  }

  clickCall(row: CallStat) {
    this.router.navigate(['call', row.ID_SAV_SUIVI]);
  }


  public getData(): any[] {

    var newAr = JSON.parse(JSON.stringify(this.nbCodePanne));
    newAr.unshift({ ID_MACHINE_SUIVIE: 'Au : ' + this.getNiceDate(this.endCP), NUMERO_SERIE: 0 , OCCURENCES : 0});
    newAr.unshift({ code: 'Du : ' + this.getNiceDate(this.startCP), nb: 0 });

    return newAr;
  }

  /**
   * Nb of Code Panne for selected dates
   */
  onSubmitCodePanne() {
    if (!this.rapportInterventionsForm.valid) {
      return;
    }
    this.isLoading = true;
    let doDat: Promise<Occurence[]>[] = [];
    this.startCP = this.rapportInterventionsForm.controls.startDateCodePanne.value;
    this.endCP = this.rapportInterventionsForm.controls.endDateCodePanne.value;

    this.codesPannes.forEach(code => {
      doDat.push(this.service.getCodePannesPromise(
        code.code, this.startCP, this.endCP
      ));
    });
    let array: any[] = [];
    Promise.all(doDat).then(values => {
      console.log(values)
      for (let i = 0; i < values.length; i++) {
        // for each occurence add the panne description and add to all results
        values[i].forEach(panne => {
          panne.codePanne = this.codesPannes[i].code;
          panne.nomPanne = this.codesPannes[i].nom;
          array.push(panne)
        });
      }
      console.log(array);
      // We need to order by number of occurences
      array.sort((a, b) =>
        b.OCCURENCES - a.OCCURENCES)
      this.nbCodePanne = array;

      this.isLoading = false;
    });

  }

}
